export const educationTimeline = [
  {
    date: "2022 - present",
    cardTitle: "Job",
    cardDetailedText: "Presently working as BPM at Department of Posts",
  },
  {
    date: "2021 - 2022",
    cardTitle: "College (B.Tech) - DropOut",
    cardDetailedText:
      "B.Tech on ECE from Ramkrishna Mahato Government Engineering College, dropped out of college for job.",
  },
  {
    date: "2021",
    cardTitle: "WBJEE",
    cardDetailedText: "Secured 8640 rank in WBJEE exam",
  },
  {
    date: "2019 - 2021",
    cardTitle: "Higher Secondary Education",
    cardDetailedText:
      "Passed Higher Secondary education with 93.4% marks from Bankura Zilla School",
  },
  {
    date: "2010 - 2019",
    cardTitle: "Secondary Education",
    cardDetailedText:
      "Passed Secondary Examination with 93.14% marks from Asansol Ramakrishna Mission High School",
  },
];

export const experienceTimeline = [
  {
    date: "2022 - Present",
    cardTitle: "Branch Post Master @IndiaPost",
    cardDetailedText:
      "Working as a Branch Post Master at India Post, managing daily operations, customer service, and postal transactions. Responsible for team management and improving service efficiency.",
  },
  {
    date: "2021 - 2022",
    cardTitle: "Freelance Web Developer",
    cardDetailedText:
      "Worked as a freelance web developer creating responsive websites and web applications for various clients using React, JavaScript, and modern frontend technologies.",
  },
  {
    date: "2020 - 2021",
    cardTitle: "Web Development Intern",
    cardDetailedText:
      "Completed a web development internship where I assisted in building and maintaining websites, learned practical applications of HTML, CSS, and JavaScript in real-world projects.",
  },
  {
    date: "2019 - 2020",
    cardTitle: "Student Developer",
    cardDetailedText:
      "Participated in coding competitions and hackathons while learning programming fundamentals. Created small projects to develop skills in frontend technologies.",
  }
];
